import { render, staticRenderFns } from "./VWidget.vue?vue&type=template&id=34c2a7dc&scoped=true"
import script from "./VWidget.vue?vue&type=script&lang=js"
export * from "./VWidget.vue?vue&type=script&lang=js"
import style0 from "./VWidget.vue?vue&type=style&index=0&id=34c2a7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c2a7dc",
  null
  
)

export default component.exports